<div class="camera-container">
    <app-dialog-header headerIcon="add_a_photo" headerText="Take Picture"
        (onCloseClick)="onCancelClick()"></app-dialog-header>

    <div class="video-div">
        <video #video width="640" height="480" autoplay></video>

        <div class="button-div alignRow">
            <button mat-raised-button (click)="captureImage()">
                <mat-icon>photo_camera</mat-icon>
                <span>Take Photo</span>
            </button>
            <mat-icon style="margin-left: 0.5em; cursor: pointer;" *ngIf="videoDevices.length > 1" (click)="switchCamera()">cameraswitch</mat-icon>
        </div>
    </div>
</div>